export const languageModalTranslations = {
    en: {
        videoTitle: '',
        videoDescription: 'Please watch this quick introduction video before you continue.',
        finishPrompt: 'Please finish the video before continuing.',
        continue: 'Continue',
        back: 'Back',
        signupTypeTitle: 'Who are you signing up as?',
        signupTypeDescription: 'Please choose whether you are creating this profile as a wali or as the individual seeking marriage.',
        signupTypeWali: 'Wali',
        signupTypeIndividual: 'Individual',
    },
    sw: {
        videoTitle: '',
        videoDescription: 'Tafadhali tazama video hii fupi ya utangulizi kabla hujaendelea.',
        finishPrompt: 'Tafadhali maliza video kabla ya kuendelea.',
        continue: 'Endelea',
        back: 'Rudi',
        signupTypeTitle: 'Unajisajili kama nani?',
        signupTypeDescription: 'Tafadhali chagua kama unatengeneza wasifu huu kama walii au kama mtu binafsi anayetafuta ndoa.',
        signupTypeWali: 'Walii',
        signupTypeIndividual: 'Mtu binafsi',
    },
};
